/* eslint-disable jsx-a11y/anchor-is-valid */
import { ModalGeneral } from '../../shared/ModalGeneralComponent';

export class BackAndSearchAppointmentActions extends React.Component {
  /**
   * Constructor de la clase BackAndSearchAppointmentActions.
   * @param {object} props - Propiedades del componente React.
   */
  constructor(props) {
    super(props);
    this.state = {
      titleModal: '',
      messageModal: '',
      iconoModal: '',
      colorIco: '',
      noX: '',
      noAceptar: '',
      noCancelar: '',
    };
  }

  /**
   * Obtiene las sedes seleccionadas en formato string, separadas por '|', si hay más de una.
   * @returns {string} Sedes seleccionadas o cadena vacía.
   */
  getFilteredSelectedLocations() {
    if (compensar?.selectedAppointmentPlaces?.length > 0) {
      let selectedLocations = compensar.selectedAppointmentPlaces.map((x) => x.itemText);
      if (compensar.selectedAppointmentPlaces.length > 1) {
        return selectedLocations.join('|');
      }
      return selectedLocations.join('');
    }
    return '';
  }

  /**
   * Obtiene el nombre de la especialidad seleccionada.
   * @returns {string} Nombre de la especialidad o placeholder.
   */
  getSpecialityName() {
    if (this.state.especialidades?.length > 0 && this.state.specialitySelected) {
      const getSelectedSpeciality = this.state.especialidades.filter(
        (item) => item.ServiceCode === this.state.specialitySelected,
      );
      return getSelectedSpeciality[0]?.ServiceName || this.state.namePlaceholderSpec;
    }
    return this.state.namePlaceholderSpec || '';
  }

  /**
   * Muestra el modal de confirmación para regresar y registra el evento en dataLayer.
   * @returns {void}
   */
  showGoBackPopup() {
    dataLayer.push({
      event: 'agendar_cita_medica',
      user_id: compTools.obtenerInformacionUsuario().Nautcli,
      log_status: compTools.obtenerInformacionUsuario().RecienAutenticado,
      login_type: compTools.obtenerInformacionUsuario().TipoIdentificacion === 1 ? 'Personas' : 'Empresas',
      affiliation: 'Salud',
      bread_crumbs: 'servicios-médicos',
      option: 'Regresar',
      sede: this.getFilteredSelectedLocations(),
      especialidad: this.getSpecialityName(),
      step: 'Paso 5 Busqueda cita',
    });
    return this.activeModal(
      parseText('Form.Content.CancelMedicalAppointmentMessageTitle'),
      parseText('Form.Content.CancelMedicalAppointmentNoButton'),
      parseText('Form.Content.CancelMedicalAppointmentMessage'),
      parseText('sharedResources.Iconos.Error'),
      parseText('sharedResources.Colores.Azul'),
      parseText('sharedResources.Modal.Bolean.False'),
      parseText('sharedResources.Modal.Bolean.True'),
      parseText('sharedResources.Modal.Bolean.True'),
    );
  }

  /**
   * Maneja la acción de cancelar en el modal, redirigiendo al usuario y cerrando el modal.
   * @returns {void}
   */
  handleModalCancel() {
    window.location.href = '#headerCitasMedicas';
    this.refs.activeModal.handleClose();
  }

  /**
   * Maneja la acción de confirmación en el modal, redirigiendo al home de citas médicas.
   * @returns {void}
   */
  handleModalConfirm() {
    window.location.href = _spPageContextInfo.siteAbsoluteUrl + '/transacciones/servicios-m%C3%A9dicos/citas-medicas/';
  }

  /**
   * Activa y muestra el modal con los parámetros proporcionados.
   * @param {string} title - Título del modal.
   * @param {string} btnCerrarCancelar - Texto del botón cerrar/cancelar.
   * @param {string} message - Mensaje del modal.
   * @param {string} icono - Icono del modal.
   * @param {string} colorIco - Color del icono.
   * @param {string} noX - Indica si se muestra la X de cerrar.
   * @param {string} noAceptar - Indica si se muestra el botón aceptar.
   * @param {string} noCancelar - Indica si se muestra el botón cancelar.
   * @returns {void}
   */
  activeModal(title, btnCerrarCancelar, message, icono, colorIco, noX, noAceptar, noCancelar) {
    this.setState({
      titleModal: title,
      btnCerrarCancelar: btnCerrarCancelar,
      messageModal: message,
      iconoModal: icono,
      colorIco: colorIco,
      noX: noX,
      noAceptar: noAceptar,
      noCancelar: noCancelar,
    });
    this.refs.activeModal.handleShow();
  }

  /**
   * Renderiza el componente de botones y el modal asociado.
   * @returns {JSX.Element} Elementos JSX a renderizar.
   */
  render() {
    return (
      <div className="row" id="backAndSearchAppointmentActions">
        <ModalGeneral
          MessageTitle={this.state.titleModal}
          msg={this.state.messageModal}
          Icono={this.state.iconoModal}
          NoX={this.state.noX}
          NoAceptar={this.state.noAceptar}
          NoCancelar={this.state.noCancelar}
          colorIco={this.state.colorIco}
          AltButtonText={parseText('Form.Content.CancelMedicalAppointmentExitButton')}
          MainButtonText={parseText('Form.Content.CancelMedicalAppointmentNoButton')}
          ref="activeModal"
          MainButtonAction={this.handleModalCancel}
          AltButtonAction={this.handleModalConfirm}
        />

        <div className="row-buttons">
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 back">
            <a className="btn btn-primary" onClick={this.showGoBackPopup.bind(this)}>
              Regresar
            </a>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 next">
            <button
              type="button"
              className="btn btn-default"
              disabled={this.props.EnabledButtonComplete}
              onClick={this.props.SearchAppoinmentUser}
            >
              Buscar Cita
            </button>
          </div>
        </div>
      </div>
    );
  }
}
